import { jsx as D } from "react/jsx-runtime";
import { Intent as x } from "@blueprintjs/core";
import { DateInput3 as w, TimePrecision as g, DateRangeInput3 as R } from "@blueprintjs/datetime2";
import { formatDate as H, DateFormats as z, getValidationMessage as V } from "@strata/helper-functions";
import { FormFieldWrapper as L } from "@strata/react-form-field-wrapper";
import U from "classnames";
import * as W from "yup";
import e from "dayjs";
import tt from "dayjs/plugin/customParseFormat";
import ot from "dayjs/plugin/localizedFormat";
import "./main.scss";
import { Field as rt, useFormikContext as et, getIn as st } from "formik";
import at from "dayjs/plugin/isSameOrBefore";
e.extend(tt);
e.extend(ot);
const G = e("1/1/1900").startOf("day").toDate(), $ = e().add(200, "year").endOf("day").toDate(), X = "MDYYYY", J = (t) => t ? e(t, [X]).toDate() : null, it = (t) => t ? e(t, [`${X} LT`]).toDate() : null, K = (t) => !t || Array.isArray(t) && !t[0] ? e().startOf("month").toDate() : void 0, Q = (t, r) => t && r && e(t).isAfter(r), Z = ({
  minDate: t,
  maxDate: r
}) => Q(t, r) ? void 0 : t, b = ({
  minDate: t,
  maxDate: r
}) => Q(t, r) ? void 0 : r, Ot = (t, r) => [
  t ? e(t).toDate() : null,
  r ? e(r).toDate() : null
], S = ({
  id: t,
  name: r,
  disabled: i = !1,
  inline: o = !1,
  fill: _,
  helperText: M,
  label: Y = "",
  rightElement: A,
  placeholderText: O = void 0,
  required: F = !1,
  requiredValidationMessage: u,
  verticalSpacingSmall: E = !1,
  shortcuts: I = !1,
  showActionsBar: h = !0,
  minDate: l = G,
  maxDate: n = $,
  highlightCurrentDay: y = !0,
  showTime: a = !1,
  onChange: f = void 0,
  onBlur: N = void 0,
  onError: P,
  value: v,
  autoFocus: C = !1,
  tabIndex: T,
  inputRef: c,
  className: B
}) => /* @__PURE__ */ D(
  L,
  {
    label: Y,
    labelFor: t,
    disabled: i,
    helperText: M,
    inline: o,
    fill: _,
    required: F,
    requiredValidationMessage: u,
    verticalSpacingSmall: E,
    inputContent: /* @__PURE__ */ D(
      w,
      {
        className: U("sds_date", B),
        formatDate: (s) => H(s, a ? z.DATE_TIME : z.DATE) ?? "",
        placeholder: O ?? (a ? "MM/DD/YYYY HH:MM" : "MM/DD/YYYY"),
        parseDate: a ? it : J,
        initialMonth: K(v),
        disabled: i,
        shortcuts: I,
        fill: !0,
        showActionsBar: h,
        rightElement: A,
        minDate: Z({ minDate: l, maxDate: n }),
        maxDate: b({ minDate: l, maxDate: n }),
        onChange: f ? (s, p) => f(s ?? "", p) : void 0,
        onError: P,
        value: v ?? "",
        inputProps: {
          id: t,
          name: r,
          autoFocus: C,
          inputRef: c,
          tabIndex: T,
          intent: u ? x.DANGER : void 0
        },
        popoverProps: {
          portalClassName: "sds_date__popover__portal",
          popoverClassName: "sds_date__popover",
          onClosing: N
        },
        closeOnSelection: a ? !1 : void 0,
        showTimezoneSelect: !1,
        timePrecision: a ? g.MINUTE : void 0,
        timePickerProps: a ? {
          useAmPm: !0,
          showArrowButtons: !0,
          selectAllOnFocus: !0
        } : void 0,
        highlightCurrentDay: y
      }
    )
  }
);
S.validator = () => W.date().typeError("Invalid date").nullable();
const lt = ({
  id: t,
  disabled: r,
  inline: i,
  fill: o,
  helperText: _,
  label: M,
  rightElement: Y,
  placeholderText: A,
  required: O,
  requiredValidationMessage: F,
  verticalSpacingSmall: u,
  shortcuts: E,
  showActionsBar: I,
  minDate: h,
  maxDate: l,
  highlightCurrentDay: n,
  showTime: y,
  onChange: a,
  onBlur: f,
  onError: N,
  value: P,
  autoFocus: v,
  tabIndex: C,
  inputRef: T,
  className: c,
  validate: B = void 0
}) => /* @__PURE__ */ D(rt, { name: t, validate: B, children: ({ field: s, form: p }) => /* @__PURE__ */ D(
  S,
  {
    id: s.name,
    name: s.name,
    disabled: r,
    label: M,
    placeholderText: A,
    helperText: _,
    inline: i,
    required: O,
    requiredValidationMessage: F ?? V(s.name, p),
    verticalSpacingSmall: u,
    autoFocus: v,
    tabIndex: C,
    inputRef: T,
    shortcuts: E,
    fill: o,
    showActionsBar: I,
    rightElement: Y,
    minDate: h,
    maxDate: l,
    onChange: a ?? ((d) => p.setFieldValue(s.name, d)),
    onBlur: f ?? (() => p.setFieldTouched(s.name)),
    value: P ?? s.value,
    onError: N,
    highlightCurrentDay: n,
    showTime: y,
    className: c
  }
) });
lt.validator = S.validator;
e.extend(at);
const nt = ({
  name: t,
  disabled: r = !1,
  inline: i = !1,
  fill: o,
  helperText: _,
  label: M = "",
  startRightElement: Y = void 0,
  endRightElement: A = void 0,
  startDatePlaceholderText: O = "Start Date (MM/DD/YYYY)",
  endDatePlaceholderText: F = "End Date (MM/DD/YYYY)",
  required: u = !1,
  requiredValidationMessage: E = void 0,
  verticalSpacingSmall: I = !1,
  shortcuts: h = !0,
  minDate: l = G,
  maxDate: n = $,
  highlightCurrentDay: y = !0,
  allowSingleDayRange: a = !0,
  contiguousCalendarMonths: f = !1,
  onChange: N,
  onBlur: P = void 0,
  onError: v,
  value: C,
  autoFocus: T = !1,
  tabIndex: c,
  startInputRef: B = void 0,
  endInputRef: s = void 0,
  className: p
}) => {
  const d = et(), j = C ?? st(d.values, t), q = P ?? (() => d.setFieldTouched(t)), m = E ?? V(t, d);
  return /* @__PURE__ */ D(
    L,
    {
      label: M,
      disabled: r,
      helperText: _,
      inline: i,
      fill: o,
      required: u,
      requiredValidationMessage: m,
      verticalSpacingSmall: I,
      inputContent: /* @__PURE__ */ D(
        R,
        {
          className: U("sds_date", p),
          formatDate: (k) => H(k) ?? "",
          parseDate: J,
          initialMonth: K(j),
          disabled: r,
          allowSingleDayRange: a,
          shortcuts: h,
          minDate: Z({ minDate: l, maxDate: n }),
          maxDate: b({ minDate: l, maxDate: n }),
          onChange: N ?? ((k) => d.setFieldValue(t, k)),
          onError: v,
          value: j,
          highlightCurrentDay: y,
          contiguousCalendarMonths: f,
          fill: !0,
          startInputProps: {
            id: `${t}.0`,
            name: t,
            autoFocus: T,
            tabIndex: c,
            placeholder: O,
            intent: m != null && m[0] ? x.DANGER : void 0,
            inputRef: B,
            rightElement: Y
          },
          endInputProps: {
            id: `${t}.1`,
            name: t,
            tabIndex: c,
            placeholder: F,
            intent: m != null && m[1] ? x.DANGER : void 0,
            inputRef: s,
            rightElement: A
          },
          popoverProps: {
            portalClassName: "sds_date__popover__portal",
            popoverClassName: "sds_date__popover",
            onClosing: q
          }
        }
      )
    }
  );
};
nt.validator = (t = G, r = $, i = !0) => W.array(S.validator()).length(2, "Invalid date range.").test({
  name: "overlappingDates",
  message: "Overlapping dates.",
  test: (o) => o != null && o[0] && (o != null && o[1]) ? i ? e(o[0]).startOf("day").isSameOrBefore(e(o[1]).startOf("day")) : e(o[0]).startOf("day").isBefore(e(o[1]).startOf("day")) : !0
}).test({
  name: "dateOutOfRange",
  message: "Date out of range.",
  test: (o) => !(((o == null ? void 0 : o[0]) && e(o[0]).isBefore(t)) ?? ((o == null ? void 0 : o[1]) && e(o[1]).isAfter(r)))
});
export {
  S as DateInput,
  lt as DateInputFormik,
  nt as DateRangeInputFormik,
  Ot as createDateRange
};
//# sourceMappingURL=index.js.map
